import React from 'react';
import { useIntl } from 'react-intl';
import { useProfiles } from '../../hooks/useProfiles';

const Profiles = ({ selectedProfileId, onSelectProfile }) => {
    const { messages } = useIntl();
    const { loadingProfiles, profiles } = useProfiles();

    return (
        <section className="risk-events-tab-profiles" style={{ height: '75vh' }}>
            <section className="risk-events-tab-profiles-header">
                <p>{messages['driverPerformanceConfig_riskEvents_profiles']}</p>
            </section>
            <section className="risk-events-tab-profiles-list">
                <ul>
                    {loadingProfiles ? (
                        <li style={{ padding: '12px 8px', color: '#666' }}>
                            <p>{messages['loading'] || 'Loading...'}</p>
                        </li>
                    ) : profiles?.length === 0 ? (
                        <li style={{ padding: '12px 8px', color: '#666' }}>
                            <p>{messages['driverPerformanceConfig_riskEvents_noProfiles'] || 'No profiles available'}</p>
                        </li>
                    ) : (
                        profiles?.map((profile) => (
                            <li 
                                key={profile?.id} 
                                className={selectedProfileId === profile?.id ? 'active' : ''}
                                onClick={() => onSelectProfile(profile?.id)}
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        onSelectProfile(profile?.id);
                                    }
                                }}
                            >
                                <p>{profile?.name}</p>
                            </li>
                        ))
                    )}
                </ul>
            </section>
        </section>
    );
};

export default React.memo(Profiles);
